<script lang="ts" setup>
import { getFahrzeugColor } from "@/features/disposition/utils/colors";
import { ArrowRightIcon } from "@heroicons/vue/20/solid";
import { IAuftrag } from "@/features/abrechnung/api/useAbrechnungsplan";
import AuftragBegleitfahrt from "./AuftragBegleitfahrt.vue";
import FahrerAbgerechnetListe from "./FahrerAbgerechnetListe.vue";

defineProps<{ auftrag: IAuftrag; query: () => void; noLink?: boolean }>();
</script>

<template>
  <div class="relative whitespace-normal">
    <div class="block w-full px-4 py-2 bg-white shadow-md print:shadow-none">
      <div class="flex items-center space-x-4 leading-tight">
        <div>
          <span class="block font-medium tracking-wide text-gray-800">
            {{ auftrag.abholung.name }}
          </span>
        </div>
        <div>
          <ArrowRightIcon class="w-5 h-5 text-gray-800" />
        </div>
        <div>
          <span class="block font-medium tracking-wide text-gray-800">
            {{ auftrag.anlieferung.name }}
          </span>
        </div>
      </div>
      <div class="text-gray-800">
        <p
          class="block max-w-full"
          :class="getFahrzeugColor(auftrag.fahrzeug.fahrzeugtyp)"
        >
          <FahrerAbgerechnetListe
            :fahrer="auftrag.fahrzeug.abzurechnende_fahrer"
            :auftrag="auftrag"
            :query="query"
          />
        </p>
      </div>
      <div v-for="(begleitfahrt, index) in auftrag.begleitfahrten" :key="index">
        <div
          class="flex items-center justify-between space-x-4 text-xs leading-tight"
          :style="{
            color: begleitfahrt.typ.schriftfarbe,
            backgroundColor: begleitfahrt.typ.hintergrundfarbe,
          }"
        >
          <AuftragBegleitfahrt
            :begleitfahrt="begleitfahrt"
            :auftrag-von-datum="auftrag.abholung.datum"
            :auftrag="auftrag"
            :query="query"
          />
        </div>
      </div>
      <div v-if="!noLink" class="flex justify-end pt-1">
        <router-link
          :to="{
            name: 'abrechnung-auftrag',
            params: { auftragId: auftrag.id },
          }"
          class="block text-sm"
        >
          -> Öffnen
        </router-link>
      </div>
    </div>
  </div>
</template>
